/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Industry } from '@app/settings/industries/industries.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class IndustriesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/industries', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((industry: any) => {
          return new Industry().deserialize(industry);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(industry: Industry): Observable<Industry> {
    return this.http.put('v1/industries/' + industry.id, industry).pipe(
      map((response: HttpResponse) => {
        return new Industry().deserialize(response.data);
      })
    );
  }

  updateTranslations(industry: Industry, translations: any): Observable<any> {
    return this.http.put('v1/industries/translations/' + industry.id, translations).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }

  store(industry: Industry): Observable<Industry> {
    return this.http.post('v1/industries', industry).pipe(
      map((response: HttpResponse) => {
        return new Industry().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/industries/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Industry().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/industries/' + id);
  }
}
